import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent, ref } from 'vue';
import { formatPrice } from '@white-label-helper/helper-payment';
import { TravelInsuranceQuoteDetails } from 'ecommerce/feature-travel-insurance';
import { BOOKING_STATUSES } from '@white-label-configuration/constants';

import { Tooltip } from 'ui-shared-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'product-summary-travel-insurance-card',
  props: {
    product: null,
    selectedForCancellation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  product: {
    name: string;
    display_name?: string;
    totals: { total: number };
    status?: string;
    is_cancellable?: boolean;
    cancellation_info?: { refund_amount?: number };
  };
  selectedForCancellation?: boolean;
};

const IconButton = defineAsyncComponent(() => import('@white-label-icon/icon-button'));



const isProductCancelled = computed(() => {
  return props.product?.status?.toUpperCase() === BOOKING_STATUSES.CANCELLED;
});

const showCancellationStatus = computed(() => {
  return (props.selectedForCancellation && props.product.is_cancellable) || isProductCancelled.value;
});

const refundInfo = computed(() => {
  const toBeCancelled = showCancellationStatus.value && !isProductCancelled.value;

  const refundAmount = props.product.cancellation_info?.refund_amount;
  const originalTotal = props.product.totals.total;

  const getRefundType = () => {
    if (!toBeCancelled || refundAmount === undefined) {
      return null;
    } else if (refundAmount === 0) {
      return 'noRefund';
    } else if (refundAmount < originalTotal) {
      return 'partialRefund';
    } else {
      return 'fullRefund';
    }
  }

  return {
    refundType: getRefundType(),
    originalTotal,
    amount: refundAmount,
  }
})

return { __sfc: true,IconButton, props, isProductCancelled, showCancellationStatus, refundInfo, formatPrice, TravelInsuranceQuoteDetails, Tooltip }
}

})